import Entity from 'utilities/entity';

class Organisation extends Entity {
    
}

export default new Organisation();